var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "header-menu-button",
      class: _vm.toggleclass,
      on: { click: _vm.toggle },
    },
    [
      _c("div", {
        staticClass: "header-menu-button-icon",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "header-menu-button-text" }, [
        _vm._v("\n    " + _vm._s(_vm.openerText) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }